const HINT_403 =
  "Sign in as a provider or supervisor on this patient's care team, or re-run the pilot seed so the patient is assigned to your CareTeam ($set-accounts).";

const GENERIC_SAVE_FAILURE = "Couldn't save changes. Please try again.";

/**
 * Toast body for a failed note save. `base` is already production-safe
 * (`getUserFacingErrorMessage`). The developer 403 hint is added outside production only.
 */
export function buildNoteSaveErrorMessage({
  base,
  isProduction,
  is403,
}: {
  base: string;
  isProduction: boolean;
  is403: boolean;
}): string {
  const hint = !isProduction && is403 ? HINT_403 : '';
  return [base, hint].filter(Boolean).join(' ') || GENERIC_SAVE_FAILURE;
}
